/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

export function scrollIntoView(element, options, offset = 0, forceScroll = false) {
    // Accepts either a DOM element or a selector string
    // usage:
    // scrollIntoView(document.getElementById('myElement'));
    // scrollIntoView('.my-class', { behavior: 'smooth', block: 'start' });
    // scrollIntoView(element, { behavior: 'smooth' }, 75); // with offset of 75px
    // scrollIntoView(element, { behavior: 'smooth', block: 'start' }, 0, true); // force scroll to top even if in viewport
    // scrollIntoView(element, null, 0, true); // can also handle null options

    let el = element;
    if (typeof element === "string") {
        el = document.querySelector(element);
    }

    if (!el) {
        return false;
    }

    // Ensure options is an object even if null was passed
    const safeOptions = options || { behavior: "smooth", block: "center" };

    // If forceScroll is true, scroll the element regardless of whether it's in view
    if (forceScroll) {
        // If there's an offset and we're not on mobile, use window.scrollTo with offset
        if (offset > 0 && !isMobileView()) {
            const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition - offset,
                behavior: safeOptions.behavior || "smooth"
            });
        } else {
            const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition,
                behavior: safeOptions.behavior || "smooth"
            });
        }
        return true;
    }

    // If there's an offset and we're not on mobile, use window.scrollTo with offset
    if (offset > 0 && !isMobileView()) {
        const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementPosition - offset,
            behavior: safeOptions.behavior || "smooth"
        });
        return true;
    }

    // Use the existing isOnScreen function to check visibility
    if (!isOnScreen(el, true)) {
        el.scrollIntoView(safeOptions);
        return true;
    }

    return false;
}

export function isOnScreen(element, partial) {
    // Accepts either a DOM element or a selector string
    //usage:
    //isOnScreen(document.getElementById('myElement'), true);
    //isOnScreen('.my-class', false);

    let el = element;
    if (typeof element === "string") {
        el = document.querySelector(element);
    }
    if (!el || typeof el.getBoundingClientRect !== "function") {
        return false;
    }

    const box = el.getBoundingClientRect();

    const win = {
        h: window.innerHeight || document.documentElement.clientHeight,
        w: window.innerWidth || document.documentElement.clientWidth
    };

    const topEdgeInRange = box.top >= 0 && box.top <= win.h;
    const bottomEdgeInRange = box.bottom >= 0 && box.bottom <= win.h;

    const leftEdgeInRange = box.left >= 0 && box.left <= win.w;
    const rightEdgeInRange = box.right >= 0 && box.right <= win.w;

    const coverScreenHorizontally = box.left <= 0 && box.right >= win.w;
    const coverScreenVertically = box.top <= 0 && box.bottom >= win.h;

    const topEdgeInScreen =
        topEdgeInRange && (leftEdgeInRange || rightEdgeInRange || coverScreenHorizontally);
    const bottomEdgeInScreen =
        bottomEdgeInRange && (leftEdgeInRange || rightEdgeInRange || coverScreenHorizontally);

    const leftEdgeInScreen =
        leftEdgeInRange && (topEdgeInRange || bottomEdgeInRange || coverScreenVertically);
    const rightEdgeInScreen =
        rightEdgeInRange && (topEdgeInRange || bottomEdgeInRange || coverScreenVertically);

    const isPartiallyOnScreen =
        topEdgeInScreen || bottomEdgeInScreen || leftEdgeInScreen || rightEdgeInScreen;
    const isEntirelyOnScreen =
        topEdgeInScreen && bottomEdgeInScreen && leftEdgeInScreen && rightEdgeInScreen;

    return partial ? isPartiallyOnScreen : isEntirelyOnScreen;
}

export const onReady = (callback) => {
    if (document.readyState != "loading") callback();
    else if (document.addEventListener) document.addEventListener("DOMContentLoaded", callback);
    else document.attachEvent("onreadystatechange", function () {
        if (document.readyState == "complete") callback();
    });
};

export function getNextSibling(elem, selector) {
    var sibling = elem.nextElementSibling;

    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }
}

export function isNullOrUndefined(value) {
    return value === undefined || value === null || value === "";
}

export function extractHostname(url, tld) {
    var hostname;
    if (url.indexOf("//") > -1) {
        hostname = url.split("/")[2];
    } else {
        hostname = url.split("/")[0];
    }
    hostname = hostname.split(":")[0];
    hostname = hostname.split("?")[0];

    if (tld) {
        const hostnames = hostname.split(".");
        hostname = hostnames[hostnames.length - 2] + "." + hostnames[hostnames.length - 1];
    }

    return hostname;
}

export function containsAny(str, substrings) {
    const lstr = str.toLowerCase();
    for (let i = 0; i !== substrings.length; i++) {
        const substring = substrings[i].toLowerCase();
        if (lstr.indexOf(substring) !== -1) {
            return substring;
        }
    }
    return null;
}

export function updateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof value !== "undefined" && value !== null)
            return url.replace(re, "$1" + key + "=" + value + "$2$3");
        else {
            hash = url.split("#");
            url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
            if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
            return url;
        }
    } else {
        if (typeof value !== "undefined" && value !== null) {
            var separator = url.indexOf("?") !== -1 ? "&" : "?";
            hash = url.split("#");
            url = hash[0] + separator + key + "=" + value;
            if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
            return url;
        } else return url;
    }
}

export function getUrlParams(url = window.location) {
    let params = {};
    new URL(url).searchParams.forEach(function (val, key) {
        if (params[key] !== undefined) {
            if (!Array.isArray(params[key])) {
                params[key] = [params[key]];
            }
            params[key].push(val);
        } else {
            params[key] = val;
        }
    });
    return params;
}

//TODO: This function should be replaced with getUrlParams in code base
export function getUrlVars() {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        var paramid = hash[0].toLowerCase();
        vars.push(paramid);
        vars[paramid] = hash[1];
    }
    return vars;
}

export function convertHMS(value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 60 / 60);
    let minutes = Math.floor(sec / 60) - hours * 60;
    let seconds = sec % 60;
    let formatted = "";

    if (hours > 0) {
        formatted = hours.toString().padStart(2, "0") + ":";
    }

    formatted += minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");

    return formatted;
}

export function getWithExpiry(key) {
    let itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    let item = JSON.parse(itemStr);
    let now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage and return null
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

export function setWithExpiry(key, value, seconds) {
    let now = new Date();
    // `item` is an object which contains the original value as well as the time when it's supposed to expire
    let item = {
        value: value,
        expiry: now.getTime() + seconds * 1000
    };

    localStorage.setItem(key, JSON.stringify(item));
}

export function getCurrentLanguage(fallback) {
    return window.currentLanguage || fallback || "en";
}

export function getCurrentRegion(fallback) {
    return window.currentRegion || fallback || "NA";
}

export function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name) {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
}

export function loadScript(src, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";

    // IE
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    // Others
    else {
        script.onload = callback;
    }

    script.src = src;
    document.head.appendChild(script);
}

/**
 * Get Character Count
 * @param {string
 * @param {number}
 */
export function getCharCount(str) {
    return str.length;
}

/**
 * Get Word Count
 * @param {string}
 * @param {number}
 */
export function getWordCount(str) {
    const words = removeTags(str).split(" ");
    return words.filter((word) => word.trim() !== "").length;
}

/**
 * Trim whitespace
 * @param {string}
 * @param {string}
 */
export function trimSpaces(str) {
    return str.replace(/(^\s*)|(\s*$)/gi, "");
}

/**
 * Remove HTML Tags from string
 * @param {string}
 * @param {string}
 */
export function removeTags(str) {
    if (str === null || str === "") {
        return false;
    }

    return str.replace(/<[^>]+>/g, "");
}

export function waitForElm(selector, callback) {
    return new Promise(resolve => {
        const found = document.querySelector(selector);
        if (found) {
            if (typeof callback === "function") callback(found);
            return resolve(found);
        }

        const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
                observer.disconnect();
                if (typeof callback === "function") callback(el);
                resolve(el);
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function getBootstrapBreakpoint() {
    const breakpoints = {
        xs: window.matchMedia("(max-width: 767px)"),
        sm: window.matchMedia("(min-width: 768px) and (max-width: 991px)"),
        md: window.matchMedia("(min-width: 992px) and (max-width: 1199px)"),
        lg: window.matchMedia("(min-width: 1200px)")
    };

    for (const breakpoint in breakpoints) {
        if (breakpoints[breakpoint].matches) {
            return breakpoint;
        }
    }
}

export function isMobileView() {
    return window.matchMedia("(max-width: 767px)").matches;
}

/**
* Returns true when viewport width is below the Bootstrap "md" breakpoint (< 992px).
* This effectively treats both xs and sm as "mobile" / below medium.
*/
export function isBelowMediumView() {
    return window.matchMedia("(max-width: 991px)").matches;
}